var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page_title" },
        [
          _c("CustomBreadcrumb", {
            attrs: { suffix: "Order NO. " + _vm.orderId }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "order_nav" }, [
        _c("div", { staticClass: "nav_msg_total" }, [
          _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Order total")]),
          _vm._v(" "),
          _c("p", { staticClass: "nac_msg_num" }, [
            _vm._v(_vm._s(_vm.totalInfo.payAmount))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nav_msg_date" }, [
          _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Orders Date")]),
          _vm._v(" "),
          _c("p", { staticClass: "nac_msg_num" }, [
            _vm._v(_vm._s(_vm.orderDate))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nav_msg_status" }, [
          _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Orders Status")]),
          _vm._v(" "),
          _c("p", { staticClass: "nac_msg_num" }, [
            _vm._v(_vm._s(_vm.orderStatus))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "nav_msg_address_width" }),
        _vm._v(" "),
        _c("div", { staticClass: "nav_msg_customer" }, [
          _c("p", { staticClass: "nac_msg_name no_border" }, [
            _vm._v("Customer")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "nac_msg_num no_border" }, [
            _vm._v(_vm._s(_vm.customer))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "order_item_list" },
        _vm._l(_vm.skuList, function(item, index) {
          return _c(
            "div",
            { key: index, staticClass: "order_item" },
            [
              index !== 0 ? _c("el-divider") : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "order_item_box" }, [
                _c("div", { staticClass: "order_item_img" }, [
                  _c("img", { attrs: { src: item.skuImg } })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "order_item_right" }, [
                  _c("div", { staticClass: "order_item_title" }, [
                    _vm._v(_vm._s(item.skuName))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order_item_variant" }, [
                    _vm._v(_vm._s(item.finalSkuName))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "order_item_detail_border" }, [
                    _c("div", { staticClass: "order_item_detail" }, [
                      _c("div", { staticClass: "order_item_detail_title" }, [
                        _vm._v("Brand")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order_item_detail_content" }, [
                        _vm._v(_vm._s(item.brandName))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order_item_detail" }, [
                      _c("div", { staticClass: "order_item_detail_title" }, [
                        _vm._v("Items")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order_item_detail_content" }, [
                        _vm._v(
                          _vm._s(
                            item.serviceOrderWaitNum
                              ? item.serviceOrderWaitNum
                              : item.num
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order_item_detail" }, [
                      _c("div", { staticClass: "order_item_detail_title" }, [
                        _vm._v("Wholesale Price")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order_item_detail_content" }, [
                        _vm._v(_vm._s(item.unitPrice))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order_item_detail" }, [
                      _c("div", { staticClass: "order_item_detail_title" }, [
                        _vm._v("Total")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order_item_detail_content" }, [
                        _vm._v(_vm._s(item.commodityAmount))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "order_item_detail" }, [
                      _c("div", { staticClass: "order_item_detail_title" }, [
                        _vm._v("Items Status")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "order_item_detail_content" }, [
                        _vm._v(
                          _vm._s(_vm.handleOrderStatus(item.orderStatus, true))
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "order_track_box" }, [
        _c("div", { staticClass: "order_track_information" }, [
          _vm._v("Tracking Infomation")
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "order_track_shipping_warehouse_input" },
          [
            _c("el-input", {
              attrs: { placeholder: "Brand warehouse shipping address" },
              model: {
                value: _vm.trackInfo.shippingAddress,
                callback: function($$v) {
                  _vm.$set(_vm.trackInfo, "shippingAddress", $$v)
                },
                expression: "trackInfo.shippingAddress"
              }
            }),
            _vm._v(" "),
            !_vm.trackInfo.shippingAddress
              ? _c("div", { staticClass: "tips_error" }, [
                  _vm._v("Please enter shipping address")
                ])
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "order_track_information_detail" }, [
          _c(
            "div",
            { staticClass: "order_track_information_number" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.trackInfo.logisticsNo,
                  callback: function($$v) {
                    _vm.$set(_vm.trackInfo, "logisticsNo", $$v)
                  },
                  expression: "trackInfo.logisticsNo"
                }
              }),
              _vm._v(" "),
              !_vm.trackInfo.logisticsNo
                ? _c("div", { staticClass: "tips_error" }, [
                    _vm._v("Please enter tracking number")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "order_track_shipping_carrier" },
            [
              _vm._m(2),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { filterable: "" },
                  model: {
                    value: _vm.trackInfo.shippingCarrier,
                    callback: function($$v) {
                      _vm.$set(_vm.trackInfo, "shippingCarrier", $$v)
                    },
                    expression: "trackInfo.shippingCarrier"
                  }
                },
                _vm._l(_vm.shippingCarrierOptions, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              !_vm.trackInfo.shippingCarrier
                ? _c("div", { staticClass: "tips_error" }, [
                    _vm._v("Please select shipping carrier")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "order_track_cost" },
            [
              _vm._m(3),
              _vm._v(" "),
              _c("el-input", {
                model: {
                  value: _vm.trackInfo.cost,
                  callback: function($$v) {
                    _vm.$set(_vm.trackInfo, "cost", $$v)
                  },
                  expression: "trackInfo.cost"
                }
              }),
              _vm._v(" "),
              !_vm.trackInfo.cost
                ? _c("div", { staticClass: "tips_error" }, [
                    _vm._v("Please enter cost")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "order_track_invoice" },
            [
              _vm._m(4),
              _vm._v(" "),
              _c(
                "el-upload",
                {
                  staticClass: "upload-demo",
                  attrs: {
                    limit: 1,
                    action: _vm.uploadApi,
                    "on-success": _vm.handelSuccess,
                    "on-remove": _vm.handleRemove,
                    "file-list": _vm.fileList
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "file",
                      fn: function(ref) {
                        var file = ref.file
                        return [
                          _c(
                            "div",
                            { staticClass: "el-upload-list__item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "el-upload-list__item-name",
                                  on: {
                                    click: function($event) {
                                      return _vm.handleView(file)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(file.name) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleRemove(file)
                                    }
                                  }
                                },
                                [_vm._v("Delete")]
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small", type: "primary" } },
                    [_vm._v("+ Upload")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.trackInfo.shippingInvoiceFile &&
              _vm.trackInfo.shippingInvoiceFile.length === 0
                ? _c("div", { staticClass: "tips_error" }, [
                    _vm._v("Please upload Shipping invoice")
                  ])
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "submit", on: { click: _vm.fulfillItems } }, [
          _vm._v("Fulfill items")
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.reviewDialogVisible,
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.reviewDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "review-dialog-border" }, [
            _c("div", { staticClass: "review-dialog-pass" }, [
              _c("div", { staticClass: "review-dialog-tips" }, [
                _vm._v("Shipping Confirmation")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "review-dialog-subtips" }, [
                _vm._v(
                  "Please confirm your shipping information; edits are not allowed after 48 hours of submission."
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "review-dialog-content" }, [
                _c("div", { staticClass: "review-dialog-content-row" }, [
                  _c("div", { staticClass: "review-dialog-content-title" }, [
                    _vm._v("Shipping Warehouse :")
                  ]),
                  _c("div", [_vm._v("Brand Warehouse")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "review-dialog-content-row" }, [
                  _c("div", { staticClass: "review-dialog-content-title" }, [
                    _vm._v("Shipping Address :")
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.trackInfo.shippingAddress))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "review-dialog-content-row" }, [
                  _c("div", { staticClass: "review-dialog-content-title" }, [
                    _vm._v("Tracking Number :")
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.trackInfo.logisticsNo))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "review-dialog-content-row" }, [
                  _c("div", { staticClass: "review-dialog-content-title" }, [
                    _vm._v("Shipping Carrier :")
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.trackInfo.shippingCarrier))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "review-dialog-content-row" }, [
                  _c("div", { staticClass: "review-dialog-content-title" }, [
                    _vm._v("Cost ($) :")
                  ]),
                  _c("div", [_vm._v(_vm._s(_vm.trackInfo.cost))])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "review-dialog-content-row" }, [
                  _c("div", { staticClass: "review-dialog-content-title" }, [
                    _vm._v("Shipping invoice file :")
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "upload_file_name",
                      on: { click: _vm.reviewUploadFile }
                    },
                    [_vm._v(_vm._s(_vm.upLoadFileName))]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "review-dialog-action" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "review-dialog-confirm",
                    on: { click: _vm.confirm }
                  },
                  [_vm._v("Confirm")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading"
                      }
                    ],
                    staticClass: "review-dialog-cancel",
                    on: { click: _vm.cancel }
                  },
                  [_vm._v("Cancel")]
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order_track_shipping_warehouse" }, [
      _vm._v("Shipping Warehouse: "),
      _c("span", [_vm._v("Brand Warehouse")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order_track_information_title" }, [
      _vm._v("Tracking Number"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order_track_information_title" }, [
      _vm._v("Shipping Carrier"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order_track_information_title" }, [
      _vm._v("Cost ( USD ) "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "order_track_information_title" }, [
      _vm._v("Shipping invoice file"),
      _c("span", [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-580ed614", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-580ed614","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/shipping/shipping-detail.vue
// module id = 11D8
// module chunks = 2